<div class="header__search">
  <form class="header__search--form" [formGroup]="searchForm" (ngSubmit)="onSubmit()">
    <button
      class="margin-right"
      mat-icon-button
      color="accent"
      type="button"
      data-bs-toggle="collapse"
      data-bs-target="#gahGlobalSearchForm"
      class="margin-right"
      aria-expanded="false"
      aria-controls="gahGlobalSearchForm"
      data-bs-dismiss="isSearchClose"
      (click)="toggle()"
    >
      <mat-icon>search</mat-icon>
    </button>
    <div
      class="search-collapse collapse collapse-horizontal"
      id="gahGlobalSearchForm"
      [ngClass]="isSearchClose === true ? 'hide hide-input' : 'show show-input'"
    >
      <input
        #gahGlobalSearchInput
        class="header__search--input"
        type="text"
        autofocus
        formControlName="searchKeyword"
        (keyup)="onChangeValue($event)"
        [matAutocomplete]="gahGlobalSearchFormAuto"
        placeholder="{{ 'home-search.placeholder' | translate }}"
      />
      <mat-spinner
        class="header__search--action loader"
        *ngIf="searchForm.get('searchKeyword')?.value && isLoading"
        matSuffix
        diameter="24"
        color="accent"
      ></mat-spinner>
      <button
        class="header__search--action"
        *ngIf="searchForm.get('searchKeyword')?.value && !isLoading"
        (click)="searchForm.get('searchKeyword')?.reset()"
        mat-icon-button
        color="accent"
        type="button"
      >
        <mat-icon class="clear">close</mat-icon>
      </button>
      <button type="submit" class="btn btn-dark" mat-raised-button color="primary">Search</button>
      <mat-autocomplete
        #gahGlobalSearchFormAuto="matAutocomplete"
        [panelWidth]="'auto'"
        class="custom-auto-complete"
        classList="custom-auto-complete"
        [displayWith]="displaySearchText"
      >
        <ng-container *ngIf="results?.length > 0 && !isLoading">
          <mat-option style="display: none"></mat-option>
          <a
            class="custom-option-wrapper d-flex justify-content-start w-100 position-relative align-items-center"
            *ngFor="let result of results"
            (click)="selectedSearchItem(result)"
          >
            <div
              class="d-flex justify-content-start w-100 position-relative align-items-center custom-option"
            >
              <div class="px-2 mx-2 img-wrapper">
                <div
                  *ngIf="result?.thumbnail_url"
                  [style.backgroundImage]="'url(' + result?.thumbnail_url + ')'"
                  alt=""
                  class="thumbnail_img"
                ></div>
                <div
                  *ngIf="!result?.thumbnail_url"
                  [style.backgroundImage]="'url(assets/img/default_poster_small.jpg)'"
                  alt=""
                  class="thumbnail_img"
                ></div>
              </div>
              <div class="px-2 w-100">
                <span class="badge bg-dark" [textContent]="result?.type"></span>
                <div class="my-1 text-break" [textContent]="result?.name"></div>
                <div class="d-flex my-1" *ngIf="result?.local_title_release_title_name">
                  <div class="mr-3 local-title">Local Title</div>
                  <div
                    class="text-break"
                    [textContent]="result?.local_title_release_title_name"
                  ></div>
                </div>
                <div class="d-flex my-1" *ngIf="result?.asset_category">
                  <div class="mr-3 local-title">Categories</div>
                  <div class="text-break" [textContent]="result?.asset_category"></div>
                </div>
              </div>
            </div>
          </a>
          <hr class="titles_page--hr" />
          <a
            (click)="onSubmit()"
            class="custom-all-option"
            *ngIf="searchForm.get('searchKeyword')?.value && !isLoading"
          >
            <div class="d-flex justify-content-between mx-auto">
              <mat-icon class="icon">search</mat-icon>
              <span
                class="fw-bold text-break mx-3"
                [innerHtml]="'&quot;' + searchForm.get('searchKeyword')?.value + '&quot;'"
              ></span>
              <span class="text-break"> click here to view all results </span>
            </div>
          </a>
        </ng-container>
      </mat-autocomplete>
    </div>
  </form>
</div>
